// filepath: /c:/Git/olegorlenko.com_FE/src/Blogs/BlogPage.js
import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import SEO from '../components/SEO';
import Breadcrumb from '../components/Breadcrumb';
import PostStats from '../components/PostStats';
import '../Styles/Blog.css';

// Import social media icons
import twitterImg from '../Images/twitter.png';
import linkedinImg from '../Images/linkedin.png';

function BlogPage() {
    const { slug } = useParams();
    const [content, setContent] = useState('');
    const [article, setArticle] = useState(null);
    const [isValidSlug, setIsValidSlug] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        document.body.classList.add('no-background');
    
        return () => {
            document.body.classList.remove('no-background');
        };
    }, []);

    useEffect(() => {
        setIsLoading(true);
        setError(null);

        // Fetch articles metadata
        fetch('/articles/index.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch articles metadata');
                }
                return response.json();
            })
            .then(data => {
                const foundArticle = data.articles.find(a => a.slug === slug);
                if (foundArticle) {
                    setArticle(foundArticle);
                    // Fetch article content
                    return fetch(`/articles/${slug}.html`);
                } else {
                    setIsValidSlug(false);
                    throw new Error('Article not found');
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch article content');
                }
                return response.text();
            })
            .then(data => {
                setContent(data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error:', error);
                setError(error.message);
                setIsValidSlug(false);
                setIsLoading(false);
            });
    }, [slug]);

    if (isLoading) {
        return <div className="loading">Loading...</div>;
    }

    if (!isValidSlug || !article) {
        return <Navigate to="/404" replace />;
    }

    // Convert date string to ISO format for meta tags
    const publishedDate = new Date(article.date).toISOString();

    // Prepare breadcrumb structured data
    const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://olegorlenko.com"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Blog",
                "item": "https://olegorlenko.com/blog"
            },
            {
                "@type": "ListItem",
                "position": 3,
                "name": article.category,
                "item": `https://olegorlenko.com/blog?category=${article.category}`
            },
            {
                "@type": "ListItem",
                "position": 4,
                "name": article.title,
                "item": `https://olegorlenko.com/blog/${slug}`
            }
        ]
    };

    return (
        <div className="BlogPost">
            <SEO
                title={article.title}
                description={article.description}
                keywords={article.keywords}
                image={article.image}
                url={`/blog/${slug}`}
                publishedTime={publishedDate}
                modifiedTime={publishedDate}
            />
            <Breadcrumb article={article} />
            <script type="application/ld+json">
                {JSON.stringify(breadcrumbData)}
            </script>
            <div dangerouslySetInnerHTML={{ __html: content }} />
            <div className="social-share">
                <button 
                    onClick={() => window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(article.title)}&url=${encodeURIComponent(window.location.origin + `/blog/${slug}`)}`, '_blank')}
                    className="share-button twitter"
                >
                    <img src={twitterImg} alt="Share on Twitter" />
                    Share on Twitter
                </button>
                <button 
                    onClick={() => window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.origin + `/blog/${slug}`)}&title=${encodeURIComponent(article.title)}`, '_blank')}
                    className="share-button linkedin"
                >
                    <img src={linkedinImg} alt="Share on LinkedIn" />
                    Share on LinkedIn
                </button>
                <PostStats slug={slug} />
            </div>
        </div>
    );
}

export default BlogPage;